<div class="pedido-cancelamento-info">
    <!-- ERP -->
    <div class="alert alert-danger" role="alert" *ngIf="config?.isOrigemERP">
        <i class="fas fa-ban"></i> Pedido cancelado no ERP
    </div>    

    <!-- E-commmerce -->
    <div class="alert alert-danger" role="alert" *ngIf="config?.isOrigemEcommerce">
        <i class="fas fa-ban"></i> Pedido cancelado no E-commerce
    </div>    


    <div class="row">
        <div class="form-group col-12 col-md-9" *ngIf="config?.isShowUsuarioCancelamento">
            <label for="canceladoPor" class="col-form-label">Cancelado Por</label>
            <input type="text" class="form-control" [value]="usuarioCancelamento?.nome" name="canceladoPor" id="canceladoPor"
                disabled="disabled" readonly="readonly">
        </div>
        <div class="form-group col-12 col-md-3">
            <label for="dataCancelamento" class="col-form-label">Cancelado em</label>
            <input type="text" class="form-control text-center" [value]="dataCancelamento | date: 'dd/MM/yyyy - HH:mm:ss'" name="dataCancelamento" id="dataCancelamento"
                disabled="disabled" readonly="readonly">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label for="nomeMotivoCancelado" class="col-form-label">Motivo</label>
            <input type="text" class="form-control" [value]="nomeMotivoCancelado ? nomeMotivoCancelado : ''" name="nomeMotivoCancelado" id="nomeMotivoCancelado"
                disabled="disabled" readonly="readonly">
            <p class="form-text text-muted">Motivo pelo qual este pedido foi cancelado</p>
        </div>
    </div>    
    <div class="row">
        <div class="form-group col-12">
            <label for="motivoCancelamento" class="col-form-label">Justificativa</label>
            <textarea class="form-control" [value]="motivoCancelamento" name="motivoCancelamento" id="motivoCancelamento"
                rows="10" disabled="disabled" readonly="readonly">
            </textarea>
            <p class="form-text text-muted">Justificativa do por que este pedido foi cancelado</p>
        </div>
    </div>
</div>